var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "section" },
    [
      _c("content-container", [
        _c("div", { staticClass: "content-wrapper" }, [
          _c("h2", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
          _vm._v(" "),
          _vm.description
            ? _c("p", { staticClass: "description" }, [
                _vm._v(_vm._s(_vm.description)),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "small-card-list-wrapper" }, [
          _c(
            "ul",
            { staticClass: "small-card-list" },
            _vm._l(_vm.cards, function (card) {
              return _c(
                "li",
                { key: card.itemId, staticClass: "small-card-list-item" },
                [
                  _c("menu-card", {
                    attrs: {
                      name: card.name,
                      price: card.price,
                      description: card.description,
                      allergyIcons: card.allergyIcons,
                      image: card.image,
                      vegetarian: card.vegetarian,
                      vegan: card.vegan,
                      glutenFree: card.glutenFree,
                      spicy: card.spicy,
                      isAlcohol: card.isAlcohol,
                    },
                    on: {
                      editItem: function ($event) {
                        return _vm.$emit("showAddItemModal", card.itemId)
                      },
                    },
                  }),
                ],
                1
              )
            }),
            0
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }